import React from 'react';

const OurFounder: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-16 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Content Section */}
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl lg:text-5xl font-bold text-slate-800 tracking-tight">
              Our Founder
            </h1>
            <div className="h-1 w-20 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full"></div>
          </div>

          <div className="space-y-6 text-slate-600 leading-relaxed">
            <div>
              <h2 className="text-xl font-semibold text-slate-700 mb-3">
                Visionary Leadership of Late Sh. L.D. Pathak
              </h2>
              <p>
                Ever Green Sr. Sec. School, Haldwani, stands as a testament to the vision and dedication of 
                its esteemed founder, Late Sh. L.D. Pathak. A visionary educationist and humanitarian, he 
                firmly believed in the transformative power of education to shape young minds and build a 
                better society.
              </p>
            </div>

            <p>
              His dream was to create an institution where students would not only excel academically but 
              also embrace values of integrity, compassion, and social responsibility. His philosophy 
              centered on nurturing well-rounded individuals who contribute positively to society, 
              equipped with both knowledge and strong moral character.
            </p>

            <p>
              Under his leadership, Ever Green Sr. Sec. School became a beacon of holistic education. 
              Nestled in the heart of Haldwani, the school provides an environment where students grow 
              intellectually, physically, emotionally, and spiritually. Late Sh. L.D. Pathak's legacy continues 
              to inspire the institution, ensuring that his vision of empowering future generations through 
              quality education lives on.
            </p>

            <p>
              Today, the school proudly upholds his ideals, fostering excellence in every sphere while 
              preparing students to face the challenges of the modern world with confidence and character.
            </p>
          </div>
        </div>

        {/* Image Section */}
        <div className="lg:order-last">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-200 to-indigo-200 rounded-2xl transform rotate-3"></div>
            <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-200">
              <div className="aspect-[4/5] bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center">
                <div className="text-center space-y-4 p-8">
                  <div className="w-32 h-32 bg-slate-300 rounded-full mx-auto flex items-center justify-center">
                    <svg className="w-16 h-16 text-slate-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-2xl font-bold text-slate-800">
                      Late Sh. L.D Pathak
                    </h3>
                    <p className="text-red-500 font-semibold text-lg">
                      Founder Chairman
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom accent */}
      <div className="mt-16 text-center">
        <div className="inline-flex items-center space-x-2 text-slate-500">
          <div className="h-px w-8 bg-slate-300"></div>
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.293l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z" clipRule="evenodd" />
          </svg>
          <div className="h-px w-8 bg-slate-300"></div>
        </div>
      </div>
    </div>
  );
};

export default OurFounder;